export default "__VITE_ASSET__PMAxOI_F__"